// AUTO-GENERATED by scripts/write-version.js — do not edit by hand.
export const BUILD_ID = "20261029121131-69a88e1d";
export const BUILT_AT = "2026-10-29T12:11:31.489Z";
